import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    minWidth: '100%',
    margin: 0,
  },
  chartGrid: {
    width: '100%',
    height: '100%',
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridTemplateRows: 'repeat(2, 1fr)',
    gap: '1.25rem 1.25rem',
  },
  label: {
    fontSize: '0.625rem',
    lineHeight: 1.4,
    color: theme.palette.secondary.main,
    transform: 'translate(0, 4px) scale(1)',
  },
  rangeSelect: {
    width: '100%',
  },
  quickRange: {
    width: '100%',
    padding: '0 0.5625rem',
    fontSize: '0.875rem',
    minWidth: '10rem',
  },
  granularitySelect: {
    width: '100%',
    padding: '0 0.5625rem',
    fontSize: '0.875rem',
    minWidth: '7rem',
  },
}));

export { useStyles };
